<template>
  <div id="popup-wrap">
    <van-popup v-model="isAdmin" class="popup-wrap">
      <div class="popup-box">
        <div class="popup-header">
          <div class="popup-title">绑定微信管理员</div>
          <img src="../../../../../assets/img/h5/official/home_icon_cross.png" @click="handelCancel"/>
        </div>
        <div class="popup-content">
          <div class="explain">
            <div class="explain-title">
              <span class="font-11">说明：</span>
              <span class="explain-tip">
                <span class="font-11">绑定微信管理员，可以用管理员微信关注“守兔票务”公众号，从公众号菜单“第三方入口”进入管理台中心，查看影票订单和公众号推广收入。</span>
              </span>
            </div>

          </div>
          <div class="step-wrap">
            <div class="step-box display-flex">
              <div class="img-border">
                <div class="img-box">
                  <div id="qrcode" ref="qrcode"></div>
                  <div class="top-left"></div>
                  <div class="top-right"></div>
                  <div class="bottom-left"></div>
                  <div class="bottom-right"></div>
                </div>
              </div>
              <div class="step-div">
                <div class="step-title">步骤一</div>
                <div class="step-content">请用管理员微信扫一扫二维码</div>
                <div class="step-content">平台ID:<span>{{ platformUuid }}</span></div>
                <div class="step-content">平台密码:<span>{{ secret }}</span></div>
              </div>
            </div>
            <div class="step-box">
              <div class="step-div">
                <div class="step-title">步骤二</div>
                <div class="step-content">
                  <div>扫码打开管理员绑定链接，填写信息后，</div>
                  <div>点击“确认绑定”按钮，完成绑定</div>
                </div>
                <div class="img-right-box">
                  <img src="../../../../../assets/img/official/steps_2_1.png" alt="">
                </div>
              </div>
            </div>
            <div class="step-box">
              <div class="step-div">
                <div class="step-title">步骤三</div>
                <div class="step-content">绑定完成后，管理员微信关注“守兔票务”公众号，点击菜单“第三方入口”就可以查看影票订单和推广收益啦～</div>
                <div class="img-list-box">
                  <img  class="steps-img-3" src="../../../../../assets/img/official/steps_3.png" alt="">
                  <div class="steps-img-3-box">
                    <div class="steps-img-info">
                      <div><span class="font-10">1、微信关注“守兔票务”</span></div>
                      <div><span class="font-10">2、选择第三方入口</span></div>
                      <img src="../../../../../assets/img/official/steps_3_1.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2';
  import { getPlatformUuid } from '@/utils/auth'
  import official from '@/javaApi/official'
  const officialModel = new official()
  export default {
    name: "Admin",
    props: {},
    created() {},
    data: function () {
      return {
        loading: false,
        platformUuid: getPlatformUuid(),
        secret: '',
        isAdmin: false,
        bindAdminLink : process.env.VUE_APP_MOVIE_DOMAIN + 'movie/index/platform/bind?platformUUID=' + process.env.VUE_APP_MOVIE_PLATFORMUUID
      }
    },
    mounted:function(){
    },
    methods: {
      init: function () {
        //获取绑定管理员密码
        this.getSecret();

        this.isAdmin = true;
        setTimeout(() => {
          this.$nextTick(() => {
            //取得容器
            var e = document.getElementById("qrcode");
            var child = e.lastElementChild;
            while (child) {
              e.removeChild(child);
              child = e.lastElementChild;
            }
            setTimeout(() => {
              this.qrcode();
            }, 100);
          });
        }, 100);
      },
      //获取平台id和密码
      getSecret(){
        var that = this;
        that.loading = true;
        officialModel.getSecret({platformUuid: this.platformUuid}).then((response) =>{
          console.log(response)
          that.loading = false;
          if(response.data.code == 200) {
            that.secret = response.data.data.secret
          }
        }).catch(error=>{
          that.loading = false;
          console.log(error)
        })
      },
      //生成二维码
      qrcode(){
        var maxWidth = 80;//this.$refs.qrcode.clientWidth
        let qrcode = new QRCode(this.$refs.qrcode, {
          text: this.bindAdminLink,
          width: maxWidth,
          height: maxWidth,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
        })
      },
      handelCancel() {
        this.isAdmin = false;
      }
    }
  }
</script>

<style lang="less" scoped>
.explain{
  line-height: 17px;
  .explain-title{
    font-family: Alibaba-PuHuiTi-M;
    font-size: 14px;
    color: #FF4F76;
  }
  .explain-tip{
    margin-top: 2px;
    font-family: Alibaba-PuHuiTi-R;
    color: #666666;
  }
}
.step-wrap{
  padding-top: 3px;
  margin-bottom: 5px;
  .display-flex{
    display: flex;
  }
  .step-box{
    background: #FAFAFA;
    margin-top: 10px;
    padding: 10px 10px 0 15px;
    .img-border{
      padding: 21px 19px 7px;
      background: #FFFFFF;
      border: 1px solid #FF8D2F;
      border-bottom: 0;
      border-radius: 25px 25px 0 0;
      margin-right: 15px;
      .img-box{
        background: #FFFFFF;
        border: 1px solid rgba(255,134,34,0.10);
        padding: 5px;
        position: relative;
        .top-left, .top-right, .bottom-left, .bottom-right {
          position: absolute;
          width: 10px;
          height: 10px;
          z-index: 1;
        }
        .top-left {
          top: -1px;
          left: -1px;
          border-top: 1px solid #FF8622;
          border-left: 1px solid #FF8622;
        }
        .top-right {
          top: -1px;
          right: -1px;
          border-top: 1px solid #FF8622;
          border-right: 1px solid #FF8622;
        }
        .bottom-left {
          left: -1px;
          bottom: -1px;
          border-left: 1px solid #FF8622;
          border-bottom: 1px solid #FF8622;
        }
        .bottom-right {
          right: -1px;
          bottom: -1px;
          border-right: 1px solid #FF8622;
          border-bottom: 1px solid #FF8622;
        }
      }
    }
    .step-div{
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      justify-content: center;
      .step-title{
        background-image: linear-gradient(90deg, #FFBB47 6%, #FF8622 89%, #FF8622 89%);
        border-radius: 14px;
        font-size: 12px;
        color: #FFFFFF;
        width: 60px;
        text-align: center;
        padding: 4px 0;
        margin-bottom: 10px;
        margin-right: 8px;
      }
      .step-content{
        font-size: 12px;
        color: #222222;
        margin-bottom: 10px;
        word-break: break-all;
        span{
          color: #FF4F76;
          font-family: Alibaba-PuHuiTi-M;
        }
      }
    }
    .img-right-box{
      overflow: hidden;
      margin-right: 5px;
      img{
        float: right;
        width: 54%;
      }
    }
    .img-list-box{
      display: flex;
      align-content: flex-end;
      .steps-img-3{
        width: 54%;
      }
      .steps-img-3-box{
        display: flex;
        flex-direction: column;
        width: 46%;
        position: relative;
        .steps-img-info{
          color: #FF8622;
          width: 110%;
          position: absolute;
          bottom: 0;
          div{
            margin-bottom: 5px;
            margin-left: 2px;
          }
        }
        img{
          width: 100%;
        }
      }
    }
    .sync-btn{
      border: 1px solid #FF4F76;
      border-radius: 12px;
      font-size: 12px;
      color: #FF4F76;
      width: 120px;
      padding: 4px 0;
      text-align: center;
      margin: 10px auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/authorization/modal/Admin.vue